import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { Complaint, ComplaintPosition, DocumentAttachment } from '@icc/b2b/shared';
import { DIALOG_DATA, DialogRef } from '@icc/ui';
import { ComplaintService } from '../complaint.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ConfigService } from '@icc/shared';
import { GoogleMapsLoaderService } from '../google-maps-loader.service';

@Component({
    selector: 'icc-complaint-document-preview',
    templateUrl: './complaint-document-preview.component.html',
    styleUrls: ['./complaint-document-preview.component.scss'],
})
export class ComplaintDocumentPreviewComponent implements OnInit {
    positionsTitles = new Map<string, string[]>();
    apiLoaded = false;
    mapLoadError = false;
    mapZoom = 15;

    constructor(
        private dialogRef: DialogRef,
        @Inject(DIALOG_DATA)
        public data: {
            document: Complaint;
            positions: ComplaintPosition[];
            attachments: DocumentAttachment[];
        },
        private sanitizer: DomSanitizer,
        private complaintService: ComplaintService,
        private configService: ConfigService,
        private googleMapsLoaderService: GoogleMapsLoaderService,
        private chRef: ChangeDetectorRef
    ) {
        const showFullPositionTitles = this.configService.user?.user?.ActiveCompanyLicenseType === 'license';
        this.data.document.consents.forEach((consent) => {
            const translatedConsent = this.complaintService.data?.consents?.find(
                (item) => item.id === consent.id
            );
            if (translatedConsent) {
                consent.name = translatedConsent.name;
                consent.shortDescription = translatedConsent.shortDescription;
                consent.longDescription = translatedConsent.longDescription;
            }
            consent.shortDescription = this.sanitizer.bypassSecurityTrustHtml(consent.shortDescription as string);
        });
        this.data.positions.forEach((position) => {
            this.positionsTitles.set(position.uuid, this.complaintService.getPositionTitle(position, showFullPositionTitles));
        });
    }

    async ngOnInit(): Promise<void> {
        await this.loadGoogleMapsApi();
    }

    get markerPosition(): google.maps.LatLngLiteral | null {
        const rawLatitude = this.data.document.latitude;
        const rawLongitude = this.data.document.longitude;

        if (rawLatitude == null || rawLongitude == null) {
            return null;
        }

        const latitude = Number(rawLatitude);
        const longitude = Number(rawLongitude);

        if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
            return null;
        }

        return {
            lat: latitude,
            lng: longitude,
        };
    }

    close() {
        this.dialogRef.close();
    }

    private async loadGoogleMapsApi(): Promise<void> {
        if (!this.markerPosition) {
            return;
        }

        await this.complaintService.loaded;
        const data = this.complaintService.data;

        if (!data?.googleMapsApiKey) {
            return;
        }

        try {
            await this.googleMapsLoaderService.load(data.googleMapsApiKey, ['marker']);
            this.apiLoaded = true;
            this.chRef.detectChanges();
        } catch {
            this.apiLoaded = false;
            this.mapLoadError = true;
            this.chRef.detectChanges();
        }
    }
}
